// filters.ts
// Service function for retrieving available filter values for order tables.
// Provides retrieval operation for filter options by type.

import { tokenAxios } from '@/utils/axios';
import { GetFiltersArgs } from '@/types/order-table';

/**
 * Fetches available filter values for a given filter type.
 * @param params - Parameters including filter type
 * @returns Array of filter values for the specified type
 */
export const getFilters = async (params: GetFiltersArgs) => {
  const { data } = await tokenAxios().get<string[]>(`/api/filters/${params.type}`, {
    params,
  });
  return data;
};
